import {
  HStack,
  Image,
  Link,
  MenuDivider,
  MenuGroup,
  MenuItem,
  Text,
} from '@chakra-ui/react';
import NorthEastSharpIcon from '@gamma/ui/icons/NorthEastSharpIcon';
import { URLS, EXTERNAL_SERVICE_LOGOS } from '@investigator/shared/constants';

const { CENSYS, SHODAN, VIRUS_TOTAL } = URLS;
const {
  VIRUS_TOTAL: VIRUS_TOTAL_LOGO,
  SHODAN: SHODAN_LOGO,
  CENSYS: CENSYS_LOGO,
} = EXTERNAL_SERVICE_LOGOS;

interface ExternalIPLinksMenuProps {
  entityName: string;
  /** Optional text prefix for each link (e.g., "Search in") */
  textPrefix?: string;
  /** Whether to wrap items in a MenuGroup */
  useMenuGroup: boolean;
  /** Optional custom hover styling */
  hoverStyle?: Record<string, unknown>;
}

/**
 * Renders menu items with links to external IP analysis services
 * (VirusTotal, Shodan, Censys)
 */
export const ExternalIPLinksMenu = ({
  entityName,
  textPrefix,
  useMenuGroup,
  hoverStyle = { textDecoration: 'none' },
}: ExternalIPLinksMenuProps): JSX.Element => {
  const menuItems = (
    <>
      <MenuItem
        as={Link}
        isExternal
        href={`${VIRUS_TOTAL}/${entityName}`}
        _hover={hoverStyle}
        icon={<Image w="16px" h="16px" src={VIRUS_TOTAL_LOGO} />}
      >
        <HStack pl={textPrefix ? 0 : 1}>
          <Text>{textPrefix ? `${textPrefix} VirusTotal` : 'VirusTotal'}</Text>
          <NorthEastSharpIcon />
        </HStack>
      </MenuItem>
      <MenuItem
        as={Link}
        isExternal
        href={`${SHODAN}/${entityName}`}
        _hover={hoverStyle}
        icon={<Image w="16px" h="16px" src={SHODAN_LOGO} />}
      >
        <HStack pl={textPrefix ? 0 : 1}>
          <Text>{textPrefix ? `${textPrefix} Shodan` : 'Shodan'}</Text>
          <NorthEastSharpIcon />
        </HStack>
      </MenuItem>
      <MenuItem
        as={Link}
        isExternal
        href={`${CENSYS}/${entityName}`}
        _hover={hoverStyle}
        icon={<Image w="16px" h="16px" src={CENSYS_LOGO} />}
      >
        <HStack pl={textPrefix ? 0 : 1}>
          <Text>{textPrefix ? `${textPrefix} Censys` : 'Censys'}</Text>
          <NorthEastSharpIcon />
        </HStack>
      </MenuItem>
    </>
  );

  return (
    <>
      <MenuDivider />
      {useMenuGroup ? <MenuGroup>{menuItems}</MenuGroup> : menuItems}
    </>
  );
};
